import React, { FC } from 'react';
import Input, { CurrencyInputProps } from 'react-currency-input-field';

type Props = Omit<CurrencyInputProps, 'onChange' | 'onValueChange'> & {
  label?: string;
  className?: string;
  onChange: (value: string) => void;
  error?: string;
  inputClassName?: string;
};

const CurrencyInput: FC<Props> = ({
  label,
  className,
  inputClassName = '',
  placeholder,
  error,
  prefix = '₦',
  onChange,
  ...props
}) => {
  return (
    <div>
      <label className={`text-[#2E3031] font-medium ${className}`}>
        {label}
        <Input
          {...props}
          prefix={prefix}
          placeholder={`${prefix} ${placeholder}`}
          decimalsLimit={props.decimalsLimit ?? 2}
          onValueChange={(value) => onChange(value ?? '')}
          className={`w-full h-[46px] bg-[#FAFAFA]  z-1 relative focus:outline-none border-b-2 border-[#D5D6D7] py-3  pl-[14px] mt-2 ${inputClassName}`}
        />
      </label>
      {error && <p className='mt-1 text-[#e60a2b] text-sm'>{error}</p>}
    </div>
  );
};

export default CurrencyInput;
